<template>
  <div 
    class="BcApprovalApproverRow bg-white w-full flex flex-row justify-start items-center px-4 py-3 gap-2.5 border-b border-gray-400 hover:bg-gray-100 cursor-pointer"
    @click="showComment = !showComment"
  >
    <aw-icon 
      icon="user"
      class="approverIcon w-6 h-6 text-gray-400"
    />
    <p class="text-sm whitespace-normal">
      {{ approver.user.name + ' ' + approver.user.surname }}
    </p>
    <div class="BcApprovalApproverRow__ApprovalWrapper ml-auto flex flex-row items-center justify-center gap-2.5">
      <bc-approval-approver-approval-description :approver="approver"/>
      <button class="commentIcon__Wrapper">
        <aw-icon
          v-if="approver.note"
          icon="comment" 
          class="w-5 h-5 cursor-pointer text-gray-400"
          :class="{'text-gray-800' : showComment}"
        />
      </button>
    </div>
    <p 
      v-if="showComment && approver.note"
      class="w-full text-xs px-3"
    >
      {{ approver.note }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    approver: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showComment: false
    }
  },
}
</script>

<style lang="scss" scoped>
.BcApprovalApproverRow {
  min-height: 3.25rem;

  &:hover {
    .commentIcon__Wrapper svg {
      @apply text-gray-800;
    }
  }

  .approverIcon {
    min-width: 1.5rem;
  }

  .BcApprovalApproverRow__ApprovalWrapper {
    min-width: 10rem;
  }

  .commentIcon__Wrapper svg {
    min-width: 1.25rem;
  }
}

.commentIcon__Wrapper {
  min-width: 1.5rem;
}
</style>
